import { useEffect, useState } from "react";
import ExpandableForm from "./SearchPanel";
import { getBusinessRules } from "~/services/businessRule.services";
import BusinessRuleTable from "./businessRuleTable";
import LoadingIcon from "~/components/form/LoadingIcon";
import { useBusinessRule } from "~/hooks/businessRule/use-businessRule";
import CreateRule from "./CreateRule";

import { BusinessRuleFormValues } from "~/types/business-rule-types";
const BusinessRuleComponent = () => {
  const [businessRuleData, setbusinessRuleData] = useState<any>(null);
  const [showCreateRuleModal, setShowCreateRuleModal] = useState(false);
  const [formValues, setFormValues] = useState<BusinessRuleFormValues>({
    customerid: "",
    customername: "",
    customerzip: "",
    servicecode: "",
    status: "",
  });

  const { businessRules } = useBusinessRule();
  const SearchFields = businessRules?.viewbusinessrules?.search?.fields;

  const fetchData = async (values = formValues) => {
    console.log("Fetching updated data...");
    const queryParam = encodeURIComponent(JSON.stringify(values));
    const { data, status } = await getBusinessRules(
      `?searchparameters=${queryParam}`
    );
    if (status) {
      console.log("fetched successfully");
      setbusinessRuleData((data as any)?.data);
    }
  };

  useEffect(() => {
    void fetchData();
  }, []);

  useEffect(() => {
    void fetchData(); // Refetch on form value change
  }, [formValues]);

  const handleFormChange = (updatedValues: BusinessRuleFormValues) => {
    setFormValues(updatedValues);
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <h4 className="text-2xl font-semibold text-orange-500 p-2">
          Business Rules Dashboard
        </h4>
        <button
          className="fixed z-10 bottom-4 right-4 w-12 h-12 bg-orange-500 text-white rounded-full text-2xl flex items-center justify-center shadow-lg focus:outline-none"
          onClick={() => setShowCreateRuleModal(true)}
        >
          +
        </button>
      </div>
      <ExpandableForm
        searchFields={SearchFields}
        onFormChange={handleFormChange}
      />

      {businessRuleData != null ? (
        <div className="bg-neutral-100 rounded-lg">
          <div className="p-2">
            <BusinessRuleTable fetchData={fetchData} data={businessRuleData} />
          </div>
        </div>
      ) : (
        <LoadingIcon />
      )}
      {showCreateRuleModal && (
        <CreateRule
          closeModal={() => {
            fetchData();
            setShowCreateRuleModal(false);
          }}
        />
      )}
    </div>
  );
};

export default BusinessRuleComponent;
